"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8374],{

/***/ 88374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "WithEvents": function() { return /* binding */ WithEvents; },
  "default": function() { return /* binding */ useEvents; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 49 modules
var esm = __webpack_require__(98821);
;// CONCATENATED MODULE: ./src/helpers/events/config.ts
var amplitudeDev = "d0baaa67671a694012f8148ca07a6b8c";
var amplitudeProd = "6e3c59bf5fba9aad8e18636004359b65";

// EXTERNAL MODULE: ./src/providers/getEnv.ts
var getEnv = __webpack_require__(4266);
;// CONCATENATED MODULE: ./src/helpers/events/useEvents.ts




function useEvents() {
    (0,react.useEffect)(function() {
        var amplitudeApiKey = (0,getEnv/* default */.Z)() === "prod" ? amplitudeProd : amplitudeDev;
        // Init amplitude
        (0,esm/* init */.S1)(amplitudeApiKey);
    }, []);
    return null;
};
var WithEvents = function(param) {
    var children = param.children;
    useEvents();
    return children;
};


/***/ })

}]);